import { useState } from "react";
import { MapPin, Mail, Clock } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try { await api.post("/contact", form); toast.success("Message sent — we'll be in touch shortly!"); setForm({ name: "", email: "", message: "" }); }
    catch { toast.error("Something went wrong. Please try again."); }
    finally { setSending(false); }
  };

  return (
    <div className="container-furn py-12">
      <div className="mb-10 border-b border-border pb-6">
        <span className="overline">Get in touch</span>
        <h1 className="mt-1 font-display text-4xl font-bold uppercase tracking-tight md:text-5xl">Contact Us</h1>
      </div>
      <div className="grid gap-10 lg:grid-cols-2">
        <div className="space-y-6">
          {[[MapPin, "Store & Warehouse", "Unit 10, Blackhall Industrial Park, South Woodham Ferrers, CM3 5UW"], [Mail, "Email", "sales@furnangling.co.uk"], [Clock, "Opening Hours", "Mon–Sat 9am–6pm · Sun 10am–4pm"]].map(([Icon, t, d]) => (
            <div key={t} className="flex gap-4 border border-border bg-card p-5">
              <Icon className="h-6 w-6 shrink-0 text-accent" />
              <div><h3 className="font-display font-semibold">{t}</h3><p className="mt-1 text-sm text-muted-foreground">{d}</p></div>
            </div>
          ))}
        </div>
        <form onSubmit={submit} className="space-y-4 border border-border bg-card p-6">
          <input data-testid="contact-name" placeholder="Your name" value={form.name} onChange={set("name")} required className="w-full border border-border bg-secondary/60 px-3 py-3 text-sm outline-none focus:border-accent transition-colors" />
          <input data-testid="contact-email" type="email" placeholder="Your email" value={form.email} onChange={set("email")} required className="w-full border border-border bg-secondary/60 px-3 py-3 text-sm outline-none focus:border-accent transition-colors" />
          <textarea data-testid="contact-message" placeholder="How can we help?" value={form.message} onChange={set("message")} required rows={6} className="w-full border border-border bg-secondary/60 px-3 py-3 text-sm outline-none focus:border-accent transition-colors" />
          <button data-testid="contact-submit" disabled={sending} className="w-full bg-accent py-3.5 text-xs font-bold uppercase tracking-widest text-accent-foreground hover:brightness-110 transition-[filter] disabled:opacity-50">{sending ? "Sending…" : "Send Message"}</button>
        </form>
      </div>
    </div>
  );
}
